import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { environment } from "../../environments/environment";
import { catchError, retry, tap } from 'rxjs/operators';
import { Lead, HeaderValuePair } from "../interfaces/lead";
import { QuestionnaireService } from "./questionnaire.service";
import { QuestionType } from "../enums/question-type.enum";

@Injectable()
export class LeadService {
	skyGuid: string;
	queryObjParams: any = {};

	constructor(
		private http: HttpClient,
		private questionnaireService: QuestionnaireService
	) {
	}

	sendLead(lead: Lead, isImmediatelyLead?: boolean, isFullLead?: boolean): Observable<any> {
		let cycleType = this.questionnaireService.getCycleType();
		let campainCode = (cycleType === 'inner') ? '1096' : '1094';

		lead.Channel = this.queryObjParams.sID || lead.Channel || '23';
		lead.Target = this.queryObjParams.trg || lead.Target || 'TFH';
		lead.campaign_code = (isFullLead) ? (this.queryObjParams.cID || lead.campaign_code || campainCode) : (this.queryObjParams.caID || lead.campaign_code || campainCode);
		lead.lead_code = this.queryObjParams.lID || lead.lead_code || '5';
		lead.source_code = this.queryObjParams.src || lead.source_code || '7';
		lead.operator_code = this.queryObjParams.oID || lead.operator_code || '7';
		lead.site_page = this.queryObjParams.pID || lead.site_page || '476';
		lead.id_type = lead.id_type || '1'; //ת.ז.
		lead.phone_1_prefix = lead.phone_1_prefix || ''; //phone prefix for send SMS for Full lead
		lead.phone_1_number = lead.phone_1_number || ''; //phone number for send SMS for Full lead
		lead.clientAppType = 'cycle';
		lead.phone_advisor_prefix= lead.phone_advisor_prefix || '';
		lead.phone_advisor_number= lead.phone_advisor_number || '';
		lead.is_advisor= lead.is_advisor || '';
		lead.first_name_advisor=lead.first_name_advisor|| '';
		// lead.cID = this.queryObjParams.cID || "116";
		// lead.lID = this.queryObjParams.lID || "5";
		// lead.oID = this.queryObjParams.oID || "7";
		// lead.pID = this.queryObjParams.pID || "586";
		// lead.sID = this.queryObjParams.sID || "18";
		// lead.src = this.queryObjParams.src || "7";
		// lead.trg = this.queryObjParams.trg || "TFH";

		if (this.skyGuid) {
			lead.skyGuid = this.skyGuid;
		}  else if(isImmediatelyLead) { 
			lead.skyGuid = 'immediately_lead_guid'; 
		} else {
			lead.skyGuid = null;
		}

		console.debug("sending lead:",lead);

		return this.http.post<Lead>(environment.apiUri + '/Leads/sendLead', lead)
			// return this.http.post<Lead>('https://reqres.in/api/users', lead)
			.pipe(
				tap( // Log the result or error
					data => {
						this.skyGuid = data.skyGuid
					}
				)
			)
			.pipe(
				catchError(this.handleError('sendLead'))
			);
	}

	private handleError(methodName: string): any {
		console.log("error in method " + methodName);
	}

	resetGuid(): any {
		this.skyGuid = null;
	}

	submitMashForm(): Observable<any> {

		let qaDicArray: HeaderValuePair[];
		//let i = 0;

		let questions = this.questionnaireService.getAllAnswerdQuestions();
		let firstStep = this.questionnaireService.getStepByID("1");
		let advisorStep = this.questionnaireService.getStepByID("0");
		let phone = this.questionnaireService.getQuestion(firstStep, "3").answer.fields[0].answerValue;
		let phoneAdvisor = this.questionnaireService.getQuestion(advisorStep, "3").answer.fields[0].answerValue;
		//handel advisor... to do

		let phonePrefix:string = null;
		let phoneNumber:string = null;

		if(phone) {
			if(phone.length === 9) {
				phonePrefix = phone.slice(0,2);
				phoneNumber = phone.slice(2);
			}
			else if(phone.length === 10) {
				phonePrefix = phone.slice(0,3);
				phoneNumber = phone.slice(3);
			}
		}

		let phonePrefixAdvisor:string = null;
		let phoneNumberAdvisor:string = null;

		if(phoneAdvisor) {
			if(phone.length === 9) {
				phonePrefixAdvisor = phoneAdvisor.slice(0,2);
				phoneNumberAdvisor = phoneAdvisor.slice(2);
			}
			else if(phoneAdvisor.length === 10) {
				phonePrefixAdvisor = phoneAdvisor.slice(0,3);
				phoneNumberAdvisor = phoneAdvisor.slice(3);
			}
		}

		

		let lead: Lead = {
			first_name: this.questionnaireService.getQuestion(firstStep, "1").answer.fields[0].answerValue,
			last_name: this.questionnaireService.getQuestion(firstStep, "1").answer.fields[1].answerValue,
			Id: this.questionnaireService.getQuestion(firstStep, "2").answer.fields[0].answerValue,
			phone_1_prefix: phonePrefix,
			phone_1_number: phoneNumber,
			phone_advisor_prefix: phonePrefixAdvisor,
			phone_advisor_number: phoneNumberAdvisor,
			first_name_advisor: this.questionnaireService.getQuestion(advisorStep, "1").answer.fields[0].answerValue,
			is_advisor :(this.questionnaireService.getIsAdvisor())?'1':'0'
		};

		qaDicArray = [];
		questions.forEach(question => {
			let qaDic: HeaderValuePair = { DataHeader: question.questionText, DataValue: '' };
			switch (question.questionType) {
				case QuestionType[QuestionType.Input]:
					if (question.CRM) {//temporary
						for (let index = 0; index < question.CRM.length; index++) {
							let qaDic: HeaderValuePair = { DataHeader: question.questionText, DataValue: '' };
							qaDic.DataHeader = question.CRM[index].q;
							qaDic.DataOrderCRM = question.CRM[index].order;
							if (question.CRMFlag === "concat") {
								for (let indexFields = 0; indexFields < question.answer.fields.length; indexFields++) {
									qaDic.DataValue = qaDic.DataValue + " " + question.answer.fields[indexFields].answerValue;
								}
								qaDic.DataValue.trim();
							}
							else {
								qaDic.DataValue = question.answer.fields[index].answerValue;
							}
							qaDicArray.push(qaDic);
						}
					}
					else {
						for (let indexFields = 0; indexFields < question.answer.fields.length; indexFields++) {
							qaDic.DataValue = qaDic.DataValue + " " + question.answer.fields[indexFields].answerValue;
						}
						//if (qaDic.DataValue) {
						qaDicArray.push(qaDic);
						//}
					}

					break;
				case QuestionType[QuestionType.YesNo]:
					if (question.selectedAnswer[0] === "YES") {
						qaDic.DataValue = "כן"
					}
					else if (question.selectedAnswer[0] === "NO") {
						qaDic.DataValue = "לא"
					}
					else {
						qaDic.DataValue = question.answersOptions[question.selectedAnswer[0]].answerText;
					}

					//if (qaDic.DataValue) {
					if (question.CRMOrder) {//temporary
						qaDic.DataOrderCRM = question.CRMOrder;
					}
					qaDicArray.push(qaDic);
					//}
					break;
				case QuestionType[QuestionType.InputArray]:
					for (let answerIndex = 0; answerIndex < question.answer.fieldsArray.length; answerIndex++) {
						for (let questionIndex = 0; questionIndex < question.CRM.length; questionIndex++) {
							let qaDic: HeaderValuePair = { DataHeader: question.questionText, DataValue: '' };
							qaDic.DataHeader = question.CRM[questionIndex].q;
							qaDic.DataOrderCRM = question.CRM[questionIndex].order;
							if(question.answer.fieldsArray[answerIndex][questionIndex].answerValue){
								qaDic.DataValue = question.answer.fieldsArray[answerIndex][questionIndex].answerValue;
								qaDicArray.push(qaDic);
							}
						}
					}

					break;
				case QuestionType[QuestionType.Borrower]:

					let borrQaDic: HeaderValuePair;
					for (let answerIndex = 0; answerIndex < question.answer["answer-data"].length; answerIndex++) {
						let borrower = question.answer["answer-data"][answerIndex].fields;
						for (let questionIndex = 0; questionIndex < question.CRM.length; questionIndex++) {
							let header = question.questionId === "29" ? question.CRM[questionIndex].q.replace(/XX/g, borrower[0].answerValue) : borrower[questionIndex].answerText + " " + (answerIndex + 1);
							borrQaDic = {
								DataHeader: header,
								DataValue: borrower[questionIndex].answerValue,
								DataOrderCRM: question.CRM[questionIndex].order
							};
							if (borrQaDic.DataValue && borrQaDic.DataOrderCRM !== 48) {
								qaDicArray.push(borrQaDic);
							}
						}
					}
					break;
				default:
					break;
			}


		});

		qaDicArray.sort(function (a, b) {
			return a.DataOrderCRM - b.DataOrderCRM;
		});

		qaDicArray.map(function (item) {
			delete item.DataOrderCRM;
			return item;
		});

		console.log(qaDicArray);
		lead.DataHeaderValues = qaDicArray;

		return this.sendLead(lead, true, true); // (lead;isImmediatelyLead;isFullLead)
	}

}


// WEBPACK FOOTER //
// ./src/app/services/lead.service.ts